import { render, staticRenderFns } from "./PerformanceOverview.vue?vue&type=template&id=f3db8b08"
import script from "./PerformanceOverview.vue?vue&type=script&lang=js"
export * from "./PerformanceOverview.vue?vue&type=script&lang=js"
import style0 from "./PerformanceOverview.vue?vue&type=style&index=0&id=f3db8b08&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports